import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Phone, Loader2 } from "lucide-react";

// Dial any business number from the rep's own SBA line. Agent-first: your phone rings, press 1 to connect.
export const BusinessDialer = () => {
  const [st, setSt] = useState(null);
  const [to, setTo] = useState("");
  const [record, setRecord] = useState(false);
  const [recConsent, setRecConsent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  useEffect(() => { api.get("/telephony/status").then(({ data }) => setSt(data)).catch(() => setSt({})); }, []);

  const call = async () => {
    setBusy(true); setMsg(null);
    try {
      const { data } = await api.post("/telephony/dial", { to, record, recording_consent: record ? recConsent : false });
      setMsg(data?.ok === false ? { ok: false, text: data.message }
        : { ok: true, text: "Calling your phone now — answer, then press 1 to connect." });
    } catch (e) { setMsg({ ok: false, text: e?.response?.data?.detail || "Could not start the call." }); }
    finally { setBusy(false); }
  };

  if (st && !st.has_mapping) return null;
  return (
    <div className="mb-6 rounded-xl border-2 border-[#E5E5E0] bg-white p-4" data-testid="business-dialer">
      <h2 className="text-sm font-bold text-[#0B192C] mb-2">Call from your SBA line</h2>
      <div className="flex flex-col sm:flex-row gap-2">
        <input value={to} onChange={(e) => setTo(e.target.value)} placeholder="(555) 123-4567" inputMode="tel"
          className="flex-1 rounded-md border px-3 py-2 text-sm" data-testid="business-dialer-input" />
        <Button onClick={call} disabled={busy || !to.trim() || (record && !recConsent)} data-testid="business-dialer-call-btn">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Phone className="w-4 h-4" />} Call
        </Button>
      </div>
      {st?.recording_enabled && (
        <div className="mt-2 text-xs text-[#475569] space-y-1">
          <label className="flex items-center gap-2"><input type="checkbox" checked={record} data-testid="business-dialer-record"
            onChange={(e) => { setRecord(e.target.checked); if (!e.target.checked) setRecConsent(false); }} /> Record this call</label>
          {record && <label className="flex items-start gap-2"><input type="checkbox" checked={recConsent} data-testid="business-dialer-record-consent"
            onChange={(e) => setRecConsent(e.target.checked)} /> I confirm recording consent. The other party hears the disclosure and must press 1 first.</label>}
        </div>
      )}
      {msg && <p className={`mt-2 text-xs ${msg.ok ? "text-[#047857]" : "text-[#B91C1C]"}`} data-testid="business-dialer-msg">{msg.text}</p>}
    </div>
  );
};
